module.exports = __webpack_public_path__ + "assets/img/course_big_cat.5d9698e9.png";